import { render, staticRenderFns } from "./BayUnderDeck.vue?vue&type=template&id=4c0cb4a6&scoped=true"
import script from "./BayUnderDeck.vue?vue&type=script&lang=ts"
export * from "./BayUnderDeck.vue?vue&type=script&lang=ts"
import style0 from "./BayUnderDeck.vue?vue&type=style&index=0&id=4c0cb4a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0cb4a6",
  null
  
)

export default component.exports